(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5fa1132"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNewsletterEnterprise(root) {
      var scope = root || document;
      var blocks = scope.querySelectorAll('[data-newsletter-enterprise]');

      blocks.forEach(function (block) {
        if (block.dataset.newsletterEnterpriseReady === 'true') return;

        var checkbox = block.querySelector('[data-consent-checkbox]');
        var submitButton = block.querySelector('[data-submit-button]');

        if (!checkbox || !submitButton) return;

        function syncButtonState() {
          submitButton.disabled = !checkbox.checked;
        }

        syncButtonState();
        checkbox.addEventListener('change', syncButtonState);
        block.dataset.newsletterEnterpriseReady = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initNewsletterEnterprise(document);
      });
    } else {
      initNewsletterEnterprise(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initNewsletterEnterprise(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
